"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var convertHexToRgba = function convertHexToRgba(hex) {
  var opacity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;

  if (hex && hex.startsWith('#') && hex.length === 7) {
    hex = hex.replace('#', '');
    var r = parseInt(hex.substring(0, 2), 16);
    var g = parseInt(hex.substring(2, 4), 16);
    var b = parseInt(hex.substring(4, 6), 16);
    return "rgba(".concat(r, ",").concat(g, ",").concat(b, ",").concat(opacity / 100, ")");
  }

  return undefined;
};

var _default = convertHexToRgba;
exports["default"] = _default;
//# sourceMappingURL=convertHexToRgba.js.map